export const VerifyCommunityStatus = {
	None: 1,
	Joining: 2,
	Joined: 3,
	NoAccessCode: 4,
	InvalidAccessCode: 5,
};
